// Best-effort incognito/private-browsing detection via the Storage API quota
// heuristic. A regular Chrome/Edge window reports a quota in the tens-to-
// hundreds of GB (a large fraction of free disk space); incognito/private
// windows cap it far lower (historically ~120MB, still well under 1GB on
// current Chrome/Edge). Scoped to Chromium browsers only — Firefox/Safari
// quota behavior differs and isn't a reliable signal there, so this never
// flags those to avoid false positives.
//
// This is NOT bulletproof: browser vendors have deliberately narrowed this
// gap over time (treating incognito-detection as a privacy issue to defeat,
// the same philosophy that makes DevTools unblockable — see
// useViolationDetector.js). Treat a `true` result as strong evidence, not
// absolute proof; always fail open (return false) on any uncertainty rather
// than incorrectly blocking a legitimate student.
const INCOGNITO_QUOTA_THRESHOLD_BYTES = 500 * 1024 * 1024; // 500MB

export const detectIncognito = async () => {
  try {
    const isChromium = /Chrome|Edg\//.test(navigator.userAgent) && !/Firefox/.test(navigator.userAgent);
    if (!isChromium) return false;
    if (!navigator.storage?.estimate) return false;

    const { quota } = await navigator.storage.estimate();
    if (typeof quota !== 'number') return false;
    return quota < INCOGNITO_QUOTA_THRESHOLD_BYTES;
  } catch {
    return false;
  }
};
